import React, { useEffect, useRef, useState } from 'react'
import { DecryptedOBJ, EncryptedOBJ, EncryptedText } from '../../utils/Encryption';
import { authenAll } from '../../_actions/sso.authen';
import lineConfig from '../../_actions/authLine/lineConfig';
import { Base_API } from '../../_actions/matcher';
import { useParams } from 'react-router-dom';
import { NhealthAction } from '../../_actions/action.api';

export default function Primo() {
    let onceMount = useRef(true);
    let {primoType} = useParams();

    useEffect(async() => {
        if(onceMount.current)
        {
            initPrimoDirection();
            onceMount.current = false;
        }
    }, [])


    const initPrimoDirection = async() => {
        let lowprimoType = String(primoType).toLowerCase();
        // set url callback
        let currentURL = EncryptedText(String(location.href).split('?')[0]);
        localStorage.setItem(process.env.REACT_APP_ENC_NAME_SIGNED_CALLBACK_URL, currentURL)
       
        let lineConfigPrimo = lowprimoType === "membercardinfo" ? lineConfig.signin_primo_privilege 
        : lowprimoType === "pointhistory" ? lineConfig.signin_primo_pointhistory 
        : lowprimoType === "rewards" ? lineConfig.signin_primo_wallet : ''

        await authenAll(lineConfigPrimo); // line login + sso
        let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null; 
        console.log('line Profile: ', lineProfile);
        if(!!lineProfile)
        {
            // get member code
            let line_user = lineProfile.user_id;
            NhealthAction.GetMember(line_user)
            .then(async res => {
                if(res.isSuccess)
                {
                    // Save
                    let memberEnc = EncryptedOBJ(res.member);
                    localStorage.setItem(process.env.REACT_APP_ENC_NAME_MEMBER_LAB_DATA, memberEnc);

                    location.href = `${Base_API.pathWeb}/n-health/primo/initdest/${lowprimoType}`
                }
            })
        }
    }

    return (
        <div className="sls-loader-container">
            <div className="sls-loader"></div>
        </div>
    )
}